// TD Draft 2026-09-28 Q10 — Linien-Story: Punkte-Navigation und Tastaturbedienung für die Wisch-Karten.
// Wird nur von sections/td-q10-line-story.liquid geladen (nur Flanell-Produkte). Ohne JS bleibt die Reihe wischbar.
(function () {
  'use strict';

  function init(root) {
    if (!root || root.getAttribute('data-td-q10-ready') === 'true') return;
    var row = root.querySelector('[data-td-q10-row]');
    if (!row) return;
    root.setAttribute('data-td-q10-ready', 'true');

    var nav = root.querySelector('[data-td-q10-dots]');
    var cards = Array.prototype.slice.call(row.children);
    var dots = nav ? Array.prototype.slice.call(nav.querySelectorAll('button')) : [];
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var frame = null;

    function padStart() {
      return parseFloat(window.getComputedStyle(row).paddingLeft) || 0;
    }

    function isScrollable() {
      return row.scrollWidth > row.clientWidth + 4;
    }

    // TD Draft 2026-09-28 G7G8 (Q10 fix): Punkt 2 wurde bei 700–999px nie aktiv (Karte 2 lag hinter dem
    // maximalen Scrollweg, "am Ende → letzte Karte" sprang direkt auf Punkt 3). Jetzt: Scroll-Ziel jeder
    // Karte wie der Snap-Punkt berechnen (start oder center, siehe CSS) und auf den Scrollweg begrenzen;
    // aktiv ist die Karte, deren Ziel der aktuellen Position am nächsten liegt.
    function targetFor(card) {
      var max = Math.max(0, row.scrollWidth - row.clientWidth);
      var align = window.getComputedStyle(card).scrollSnapAlign || '';
      var left = align.indexOf('center') !== -1
        ? card.offsetLeft + card.offsetWidth / 2 - row.clientWidth / 2
        : card.offsetLeft - padStart();
      return Math.min(max, Math.max(0, left));
    }

    function activeIndex() {
      var best = 0;
      var bestDistance = Infinity;
      cards.forEach(function (card, index) {
        var distance = Math.abs(targetFor(card) - row.scrollLeft);
        if (distance < bestDistance - 1) {
          bestDistance = distance;
          best = index;
        }
      });
      return best;
    }

    function update() {
      frame = null;
      var scrollable = isScrollable();
      if (nav) nav.hidden = !scrollable;
      // Scrollbare Reihe per Tastatur erreichbar machen (Pfeiltasten scrollen), sonst kein extra Tab-Stopp
      if (scrollable) {
        row.setAttribute('tabindex', '0');
      } else {
        row.removeAttribute('tabindex');
      }
      var current = activeIndex();
      dots.forEach(function (dot, index) {
        if (index === current) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function schedule() {
      if (frame === null) frame = window.requestAnimationFrame(update);
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        var card = cards[index];
        if (!card) return;
        // TD Draft 2026-09-28 G7G8 (Q10 fix): gleiches Ziel wie activeIndex()
        row.scrollTo({ left: targetFor(card), behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });

    row.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    update();
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-td-q10]');
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  // Theme-Editor: Sektion neu geladen
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
